import { handleEditVisibleFields } from 'serviceWorker/services/visibleFields';
import { visibleFieldSource } from 'serviceWorker/services/visibleFields/visibleFieldSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { visibleFieldContract } from 'shared/domain/visibleField/visibleFieldContract';
import { serveEntityRequests } from './serveEntityRequests';

/** Answers the visible field requests: the list, and edits answered once queued. */
export function serveVisibleFieldRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(visibleFieldContract, visibleFieldSource),
    channelServer.handle(visibleFieldContract, { edit: handleEditVisibleFields }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
